import { useState } from 'react';

import { Button } from '~/components/Button';
import SelectInput from '~/components/Form/SelectInput';
import TextArea from '~/components/Form/TextArea';
import TextInput from '~/components/Form/TextInput';

const subjectOptions = [
  {
    displayValue: 'Where is my order?',
    isBuyer: true,
    value: 'Where is my order? - Sole Market Buyer'
  },
  {
    displayValue: 'Cancel my order',
    isBuyer: true,
    value: 'Cancel my order - Sole Market Buyer'
  },
  {
    displayValue: 'Wrong size',
    isBuyer: true,
    value: 'Wrong size - Sole Market Buyer'
  },
  {
    displayValue: 'General Buyer enquiry',
    isBuyer: true,
    value: 'General Buyer enquiry - Sole Market Buyer'
  },
  {
    displayValue: 'General Seller enquiry',
    value: 'General Seller enquiry - Sole Market Seller'
  },
  {
    displayValue: 'Other',
    value: 'Other'
  }
];

export default function ContactForm({
  errors,
  success
}: {
  errors?: string[];
  success?: boolean;
}) {
  const [selectedSubject, setSelectedSubject] = useState<string | undefined>();

  const showOrderNumberField = subjectOptions.find(
    (s) => s.value === selectedSubject
  )?.isBuyer;

  return (
    <>
      {success && (
        <p className="rounded bg-concrete p-4 text-lg font-semibold">
          Message sent!
        </p>
      )}
      {success === false && (
        <p className="rounded bg-concrete p-4 text-lg font-semibold">
          Something went wrong, please try again.
        </p>
      )}
      <form
        method="post"
        action="/contact/?index"
        className="mx-auto flex w-full flex-col items-start justify-center gap-4"
      >
        <div className="flex w-full flex-col gap-2">
          <label className="font-semibold" htmlFor="name">
            Name
          </label>
          <TextInput
            id="name"
            name="name"
            type="text"
            error={
              errors?.includes('name') ? 'Please enter a valid name' : undefined
            }
            placeholder="Enter your name"
            required={true}
          />
        </div>

        <div className="flex w-full flex-col gap-2">
          <label className="font-semibold" htmlFor="email">
            Email Address
          </label>
          <TextInput
            id="email"
            name="email"
            type="email"
            error={
              errors?.includes('email')
                ? 'Please enter a valid email'
                : undefined
            }
            placeholder="Enter your email address"
            required={true}
          />
        </div>

        <div className="flex w-full flex-col gap-2">
          <label className="font-semibold" htmlFor="subject">
            Subject
          </label>
          <SelectInput
            id="subject"
            placeholder="Select your subject"
            required={true}
            name="subject"
            options={subjectOptions}
            onChange={(e) => setSelectedSubject(e.currentTarget.value)}
          />
        </div>

        {showOrderNumberField && (
          <div className="flex w-full flex-col gap-2">
            <label
              className="flex items-center gap-2 font-semibold"
              htmlFor="order_number"
            >
              Sole Market order number
              <span className="font-normal text-grey-hide">(Optional)</span>
            </label>
            <TextInput
              id="order_number"
              name="order_number"
              type="text"
              error={
                errors?.includes('order_number')
                  ? 'Please enter a valid order number'
                  : undefined
              }
              placeholder="Enter your Sole Market order number"
              required={false}
            />
          </div>
        )}

        <div className="flex w-full flex-col gap-2">
          <label className="font-semibold" htmlFor="message">
            Message
          </label>
          <TextArea name="message" required />
        </div>

        <Button variant="forest" type="submit">
          Submit
        </Button>
      </form>
    </>
  );
}
